package strings

import io.github.skeptick.libres.strings.PluralForms
import io.github.skeptick.libres.strings.getCurrentLanguageCode
import kotlin.String

public object StringsTr : Strings {
  override val home: String = "Anasayfa"

  override val about: String = "Hakkında"

  override val contact: String = "İletişim"

  override val book_stands: String = "Kitap standı"

  override val search: String = "Arama yapın"

  override val create_library: String = "Mini kütüphane"

  override val footer_author: String = "Copyright 2025 dev0029"

  override val section1_title: String = "Özel günlere özel paketleme"

  override val section1_button: String = "Daha fazla bilgi"

  override val section1_desc: String =
      "Anneler günü, yılbaşı, sevgiler gibi özel günlerde farklı paketleme yapıyoruz."

  override val section2_title: String = "Yatakyanı kitap standları"

  override val section2_button: String = "Sipariş ver"

  override val section2_desc: String =
      "En beğendiğin kitabı okurken kitabı koyacağın bir kitap standı mı arıyorsun? "

  override val section3_title: String = "Kitaplığını kendin oluştur"

  override val section3_button: String = "Şimdi başla"

  override val section3_desc: String =
      "Favori kitap listeni oluştur, bizde sana minyatür kitaplığını oluşturalım"

  override val shipping_title: String = "Kargo"

  override val shipping_desc1: String = "Hızlı ve özenli kargolama"

  override val shipping_description: String =
      " Siparişleriniz özenle hazırlandıktan sonra kargoya verilir, siparişleriniz kargo durumunu sitemizden her zaman sorgulayabilirsiniz."

  override val shipping_description2: String = ""

  override val contact_title: String = "İletişime geçin"

  override val contact_email_name: String = "İsminiz"

  override val contact_email_subject: String = "Konu"

  override val contact_email_message: String = "Mesaj"

  override val contact_email_send_message: String = "Mesaj gönderin"

  override val library_header_title: String = "Kütüphanenizi oluşturun"

  override val library_header_title2: String = "Kitap listeniz oluşturuldu, şimdi sipariş zamanı!"

  override val library_header_desc: String = "*Eklediğiniz kitapların sırası önemli değildir"

  override val library_header_desc2: String =
      "Sipariş ver butonuna tıklayın ve benzersiz kodunuzu Etsy'deki \"Kişiselleştirme\" bölümüne yapıştırın."

  override val copy_your_id: String = "Benzersiz kitap listesi kodunu kopyalayın:"

  override val download_book_list: String = "Kitap listesini indir"

  override val ok: String = "Tamam"

  override val remove: String = "Kaldır"

  override val search_author: String = "Yazar ara"

  override val result_found: String = "sonuç bulundu"

  override val loading: String = "Yükleniyor:"

  override val not_load: String = "Model yüklenmedi"
}
